import React from 'react';
import './CarouselDots.scss';

const CarouselDots = () => {
  const className = 'c-CarouselDots';

  return (
    <div className={className}>
      <span className={`${className}__dot ${className}__dot--active`}></span>
      <span className={`${className}__dot`}></span>
      <span className={`${className}__dot`}></span>
    </div>
  );
};

export default CarouselDots;
